<template>
  <div class="fangdai">
    <!-- <van-nav-bar title="房产抵押贷款申请"
                 left-text="返回"
                 left-arrow
                 @click-left="$router.go(-1)"
                 :border="true" /> -->
    <van-form @submit="onSubmit">
      <van-field input-align="right"
                 v-model="form.name"
                 required
                 name="name"
                 label="申请人"
                 placeholder="申请人"
                 :rules="[{ required: true, message: '请填写申请人' },{ validator:nameValidator, message: '请输入申请人姓名应为2-5个汉字' }]" />
      <van-field input-align="right"
                 v-model="form.mobile"
                 required
                 name="mobile"
                 type="tel"
                 label="手机号码"
                 placeholder="手机号码"
                 :rules="[{ required: true, message: '请填写手机号码' },{ validator:mobileValidator, message: '请输入正确的手机号码' }]" />
      <van-field input-align="right"
                 :value="form.areaName"
                 readonly
                 clickable
                 required
                 label="所在地区"
                 placeholder="点击选择所在地区"
                 @click="showArea = true"
                 :rules="[{ required: true, message: '选择所在地区' }]">
        <template #right-icon>
          <van-icon name="arrow" />
        </template>
      </van-field>
      <van-popup v-model="showArea"
                 position="bottom"
                 round>
        <van-picker show-toolbar
                    :columns="areaColums"
                    value-key="name"
                    @confirm="onAreaComfirm"
                    @cancel="showArea = false">
        </van-picker>
      </van-popup>

      <van-field input-align="right"
                 v-show="form.areaId"
                 :value="form.villageName"
                 readonly
                 clickable
                 required
                 label="小区名称"
                 placeholder="点击选择小区"
                 @click="showViallge = true"
                 :rules="[{ required: true, message: '请选择小区' }]">
        <template #right-icon>
          <van-icon name="arrow" />
        </template>
      </van-field>
      <van-popup v-model="showViallge"
                 position="bottom"
                 round>
        <van-picker show-toolbar
                    :columns="searchColumns"
                    value-key="name"
                    @confirm="onVillageConfirm"
                    @cancel="showViallge = false">
          <template #title>
            <van-search v-model="searchKey"
                        clearable
                        style="    margin-top: 10px;    width: 60%;"
                        placeholder="请输入小区名称搜索" />
          </template>

        </van-picker>
      </van-popup>

      <van-field input-align="right"
                 v-model="form.detailAddress"
                 required
                 name="detailAddress"
                 label="详细地址"
                 placeholder="详细地址"
                 :rules="[{ required: true, message: '请填写详细地址' }]" />
      <van-field input-align="right"
                 :value="form.deptName"
                 readonly
                 clickable
                 required
                 name="deptName"
                 label="受理网点"
                 placeholder="点击选择受理网点"
                 @click="showDot = true"
                 :rules="[{ required: true, message: '请选择受理网点' }]">
        <template #right-icon>
          <van-icon name="arrow" />
        </template>
      </van-field>
      <van-popup v-model="showDot"
                 position="bottom"
                 round>
        <van-picker show-toolbar
                    :columns="dotColums"
                    value-key="deptName"
                    @confirm="dotConfirm"
                    @cancel="showDot = false" />
      </van-popup>

      <!--            <div style="margin: 16px;">-->
      <!--                <van-checkbox v-model="aggree" shape="square" style="font-size: 12px" icon-size="14">阅读并同意《相关条款》</van-checkbox>-->
      <!--            </div>-->
      <div style="margin: 16px;">
        <van-button round
                    block
                    type="info"
                    native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { getAreaList, getVillageList, loadSave, getDeptList } from '@/api/public'
import { Toast } from 'vant';

export default {
  name: 'fangdai',
  data () {
    return {
      form: {
        name: '',
        mobile: '',
        areaId: '',
        areaName: '',
        villageId: '',
        villageName: '',
        detailAddress: '',
        deptId: '',
        deptName: '',
        state: '0'
      },
      showArea: false,//所属地区pick
      showViallge: false,//所属小区pick
      showDot: false,
      areaColums: [],
      villageColums: [],
      searchColumns: [],
      dotColums: [],
      searchKey: ''
    }
  },
  created () {
    this.getList();
    this.getDeptList();
  },
  watch: {  //实时监听搜索输入内容
    searchKey: function () {
      let key = String(this.searchKey);
      key = key.replace(/\s*/g, "");//去除搜索内容中的空格
      const reg = new RegExp(key, "ig");//匹配规则-i：忽略大小写，g：全局匹配
      /* 进行筛选，将筛选后的数据放入新的数组中，‘name’键可根据需要搜索的key进行调整 */
      this.searchColumns = this.villageColums.filter(item => item.name.match(reg) != null);
    }
  },
  methods: {
    getList () {
      getAreaList().then((res) => {
        this.areaColums = res.data;
      }).catch(e => {
        console.log(e);
      })
    },
    getVillageList () {
      getVillageList(this.form.areaId).then((res) => {
        this.villageColums = res.data;
        this.searchColumns = res.data;
      }).catch(e => {
        console.log(e);
      })
    },
    getDeptList () {
      getDeptList().then(res => {
        let data = [];
        res.data.forEach(element => {
          data.push({ deptId: element.deptId, deptName: element.deptName });
        });
        this.dotColums = data;
      });
    },
    onAreaComfirm (value) {//小区选择
      debugger;
      this.form.areaName = value.name;
      this.form.areaId = value.areaId;
      this.getVillageList();
      this.showArea = false;
    },
    onVillageConfirm (value) {
      debugger;
      this.form.villageId = value.villageId;
      this.form.villageName = value.name;
      this.showViallge = false;
    },
    dotConfirm (value) {
      debugger;
      this.form.deptName = value.deptName;
      this.form.deptId = value.deptId;
      this.showDot = false;
    },
    onSubmit () {
      loadSave(this.form).then((res) => {
        Toast.success(res.msg);
        this.$router.push({
          path: '/index',
        });
      }).catch(e => {
        console.log(e);
      })
    },
    mobileValidator (val) {
      return /^1(3|4|5|7|8|9|6)\d{9}$/i.test(val);
    },
    nameValidator (val) {
      return /^[\u4e00-\u9fa5]{2,5}$/.test(val);
    },
  }
}
</script>
<style lang="less">
.fangdai {
  .van-field__error-message {
    text-align: right;
  }
}
</style>


